import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { SELF } from '../../../../shared/constants';
import { useActiveDeviceStream } from '../../../../shared/features/device-manager/hooks';
import { getUserSelector } from '../../../../shared/features/user';
import { selectCameraDevicePermission } from '../../features/device/selectors';
import { getParticipant } from '../../selectors';
import { TrackState } from '../../types';
import Participant from '../participant';

function hasActiveVideoTrack(stream?: MediaStream): boolean {
    if (!stream) {
        return false;
    }

    return stream.getVideoTracks().some((track) => track.readyState === 'live' && track.enabled);
}

export const GoloomJoinParticipantContainer: React.FC = ({ children }) => {
    const user = useSelector(getUserSelector);
    const self = useSelector((state) => getParticipant(state, SELF));
    const mediaStream = useActiveDeviceStream('videoinput');
    const cameraPermission = useSelector(selectCameraDevicePermission);

    // Во время запроса разрешения камеры videoTrackState может не отражать реальное наличие видео.
    // Определяем состояние по фактическому стриму: есть видео - показываем, нет - аватар.
    const isPermissionPending = cameraPermission === 'prompt' || cameraPermission === undefined;

    const effectiveVideoTrackState = useMemo((): TrackState | undefined => {
        if (isPermissionPending) {
            if (hasActiveVideoTrack(mediaStream)) {
                return { id: 'preview', muted: false };
            }

            return undefined;
        }

        return self.videoTrackState;
    }, [isPermissionPending, mediaStream, self.videoTrackState]);

    return (
        <Participant
            id={SELF}
            uid={user?.uid}
            avatarUrl={self.avatarUrl}
            shouldRenderAvatar={self.shouldRenderAvatar}
            isFromOverlay
            videoTrackState={effectiveVideoTrackState}
            videoStream={mediaStream}
        >
            {children}
        </Participant>
    );
};
